import type { FC } from 'react'
import React from 'react'
import clsx from 'clsx'
import styles from './Tooltip.module.scss'

export interface TooltipProps {
  isActive?: boolean
  position: 'right' | 'left' | 'top' | 'bottom'
  contentCenter: 'center' | 'left' | 'right'
  content?: React.ReactNode
  children?: React.ReactNode
  noticeBorder?: boolean
  notDotted?: boolean
}

const Tooltip: FC<TooltipProps> = ({
  content,
  contentCenter,
  position = 'top',
  children,
  noticeBorder = false,
  notDotted = false,
}) => {
  const tooltipClassName = clsx({
    [styles.tooltip]: true,
    [styles.top]: position === 'top',
    [styles.left]: position === 'left',
    [styles.right]: position === 'right',
    [styles.bottom]: position === 'bottom',
    [styles.contentCenter]: contentCenter === 'center',
    [styles.contentLeft]: contentCenter === 'left',
    [styles.contentRight]: contentCenter === 'right',
  })
  return (
    <span
      className={clsx(styles.tooltipText, {
        [styles.dotted]: !!content && !notDotted,
        [styles.dottedNotice]: noticeBorder && !notDotted,
      })}
    >
      {content && <span className={tooltipClassName}>{content}</span>}
      {children}
    </span>
  )
}

export default Tooltip
